module.exports = __webpack_public_path__ + "static/media/ga.f9027ac0.svg";